module.exports = __webpack_public_path__ + "img/6.1fafa97b.jpg";